import { render, staticRenderFns } from "./Revenue-report.vue?vue&type=template&id=398ff3af"
import script from "./Revenue-report.vue?vue&type=script&lang=js"
export * from "./Revenue-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports